import AboutPage from './About';
import ContactPage from './Contact';
import FrontPage from './Front';
import LoadingPage from './Loading';
import NotSupported from './NotSupported';
import ProjectsPage from './Projects';
import ServicesPage from './Services';
import TechStackPage from './TechStack';

export {
  AboutPage,
  ContactPage,
  FrontPage,
  LoadingPage,
  NotSupported,
  ProjectsPage,
  ServicesPage,
  TechStackPage
};
